import styled from 'styled-components';
import { Card, Avatar } from 'antd';

export const StyledAvatar = styled(Avatar)`
  width: 150px;
  height: 150px;
  margin-bottom: 16px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

export const ProfileCard = styled(Card)`
  margin-bottom: 24px;
  box-shadow: 
    0 1px 3px rgba(0, 0, 0, 0.06),
    0 2px 6px rgba(0, 0, 0, 0.04);
  border-radius: 16px;
  border: 1px solid #e8e8e8;
`;

